"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _Keyboard = require("../../../enums/Keyboard");
var _IconChevronDown = _interopRequireDefault(require("../../../icons/General/IconChevronDown"));
var _styles = require("./styles");
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const TableRow = ({
  onClick,
  expandable,
  expandableContent,
  defaultExpanded,
  trackingEvent,
  trackingName,
  children
}) => {
  const [expanded, setExpanded] = (0, _react.useState)(!!defaultExpanded);
  const handleKeyPress = isExpand => e => {
    if (e.key === _Keyboard.Key.enter || e.key === _Keyboard.Key.space) {
      e.preventDefault();
      isExpand ? setExpanded(!expanded) : onClick && onClick(e);
    }
  };
  const ButtonContent = children && /*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.ButtonWrapper, {
    onClick: onClick,
    className: "table-row-button",
    "data-tracking-name": trackingName,
    "data-tracking-event": trackingEvent,
    role: "button",
    tabIndex: 0,
    onKeyDown: handleKeyPress(false),
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
      children: children
    })
  });
  const ExpandableContent = children && /*#__PURE__*/(0, _jsxRuntime.jsxs)(_styles.ExpandableWrapper, {
    className: "table-row-expandable",
    role: "button",
    children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)(_styles.ExpandButtonWrapper, {
      onClick: () => setExpanded(!expanded),
      onKeyDown: handleKeyPress(true),
      tabIndex: 0,
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
        children: children
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.IconWrapper, {
        className: "expand-icon",
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_IconChevronDown.default, {
          flipVertical: expanded,
          size: "12px"
        })
      })]
    }), expanded ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.ExpandableContentWrapper, {
      className: "expandable-content",
      children: expandableContent
    }) : null]
  });
  const Content = /*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.Wrapper, {
    className: "table-row",
    children: children
  });
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_react.Fragment, {
    children: expandable ? ExpandableContent : onClick ? ButtonContent : Content
  });
};
var _default = exports.default = TableRow;